import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface PageLoaderProps {
  /**
   * Optional custom message to display below the spinner.
   * Defaults to "Loading..."
   */
  message?: string;
  /**
   * Optional className to apply to the container.
   */
  className?: string;
}

/**
 * PageLoader Component
 *
 * A reusable full-page loader component that fills the main content area
 * and displays a centered spinner with an optional message.
 *
 * Use this component for page-level loading states where the entire
 * page content is being loaded.
 *
 * The component uses viewport height calculations to account for the header
 * (h-12 = 3rem) and centers the loader vertically and horizontally.
 */
export function PageLoader({ message = "Loading...", className }: PageLoaderProps) {
  return (
    <div className={cn("flex items-center justify-center p-6 min-h-[calc(100vh-3rem)]", className)}>
      <div className="flex flex-col items-center gap-2">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        <p className="text-sm text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}
